import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { InfoIcon } from 'src/common/icons';
export const InfoIconButton = ({ onClick, ariaLabel, dataTestId, iconSize = 14 }) => (_jsx("button", { onClick: onClick, style: {
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
    }, "data-testid": dataTestId, "aria-label": ariaLabel, type: "button", children: _jsx(InfoIcon, { size: iconSize }) }));
